import { FormField } from '../form-field';

/**
 * Every control name a section owns, including those of sections nested inside it.
 *
 * Sections are flattened by createForm() — their fields become controls on the root
 * form group, keyed by the field's name exactly as written (so 'location.city' is a
 * literal key, not a path). A section itself contributes no control.
 */
export function collectFieldNames(fields: FormField[] | undefined): string[] {
    return (fields ?? []).flatMap((field: any) => {
        if (field?.type === 'section') {
            return collectFieldNames(field.fields);
        }
        return field?.name ? [field.name] : [];
    });
}
